export function FormatCurrency(amount) {
    return (parseInt(amount) / 100).toFixed(2);
}

export function WorkOutDepositPrice(amount, deposit) {
    // console.log(amount);
    // console.log(deposit);
    // console.log(parseInt(parseInt(amount) / parseInt(deposit)));
    return parseInt(parseInt(amount) / parseInt(deposit));
}

export function WorkOutRemainingPayment(total, alreadyPaid) {
    return parseInt(total) - parseInt(alreadyPaid);
}
